import React, { Component } from 'react'
import { CONTRACT_TYPE } from '../../common/utils/static-data';
export class Tabs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabActive: CONTRACT_TYPE.has_driver
        }
        this.tabData = [
            {
                title: 'Hợp đồng có lái',
                id: CONTRACT_TYPE.has_driver
            },
            {
                title: 'Hợp đồng không lái',
                id: CONTRACT_TYPE.without_driver
            },
            // {
            //     title: 'Hợp đồng quản lý lái xe',
            //     id: 3
            // },
            // {
            //     title: 'Hợp đồng quản lý xe',
            //     id: 4
            // }
        ]
    }

    onChangeTab = tab => {
        this.setState({ tabActive: tab }, ()=>{
            this.props.onChangeTab(tab)
        })
    }

    render() {
        const { tabActive } = this.state;
        return (
                <div className="nav-tabs ">
                    {this.tabData.map(value => {
                        return <div
                            key={value.id}
                            onClick={() => this.onChangeTab(value.id)}
                            className={`nav-link ${tabActive === value.id ? 'active' : ''}`}>
                            {value.title}
                        </div>
                    })}

                </div>
        )
    }
}
